stzh-upload {
  @include host;
  --hint-color: var(--stzh-upload-hint-color, #{$colorSecondary60});

  --list-grid-template-areas: var(
      --stzh-upload-list-grid-template-areas,
      "list list list list"
  );

  --list-grid-template-columns: var(
      --stzh-upload-list-grid-template-columns,
      #{$gridColumns}
  );

  @include mq($from: small) {
    --list-grid-template-areas: var(
        --stzh-upload-list-grid-template-areas,
        "list list list ."
    );
  }

  @include mq($from: medium) {
    --list-grid-template-areas: var(
        --stzh-upload-list-grid-template-areas,
        "list list list list list . . ."
    );

    --list-grid-template-columns: var(
        --stzh-upload-list-grid-template-columns,
        #{$gridColumnsMedium}
    );
  }

  &[disabled]:not([disabled="false"]) {
    --description-color: #{$formDisabledColor};
  }
}

.stzh-upload {
  @include input-description;
  @include font;
  position: relative;
  color: $colorGrey70;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  &__label {
    @include font('title');
    @include fontCurve('h4');
    color: $headingColor;
    margin-bottom: space('small');
  }

  &__clickarea {
    @include fontSize('milli');
    @include spaceCurve('padding', 'medium');
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: space('medium');
    text-align: center;
    border: 1px solid $colorBlack; // color has no effect, comes from image
    background-color: $colorGrey10;
    border-image-source: inline('./assets/border.png');
    border-image-slice: 8;
    border-image-width: 8px;
    border-image-repeat: round;
    transition: background-color $baseTransitionAnimationSpeed;

    @include retina() {
      border-image-source: inline('./assets/border@2x.png');
      border-image-slice: 16;
    }
  }

  &__heading-wrapper {
    width: 100%;
    @include font('heavy');
    @include fontSize('milli');
    display: flex;
    align-items: flex-start;
    gap: space('medium');
    color: $colorGrey90;
    transition: color $baseTransitionAnimationSpeed;
  }

  &__heading-inner-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: space('xsmall');
  }

  &__buttons-wrapper {
    display: flex;
    flex-direction: column;
    gap: var(--stzh-space-medium);
    width: 100%;

    @include mq($from: medium) {
      flex-direction: row;
      justify-content: center;
    }
  }

  &__button,
  &__button-scan {
    width: 100%;
  }

  &__hint-wrapper {
    @include font;
    @include fontSize('micro');
    display: flex;
    align-items: center;
    gap: space('xsmall');
    color: var(--hint-color);
  }

  &__instructions {
    @include fontSize('nano');
  }

  stzh-icon#{&}__delete-icon {
    display: none;
  }

  &__previews-wrapper {
    @include grid;
    grid-template-areas: var(--list-grid-template-areas);
    grid-template-columns: var(--list-grid-template-columns);
  }

  &__previews-inner-wrapper {
    grid-area: list;
  }

  &__previews-message-wrapper {
    display: block;
    margin-top: space('medium');
  }

  &__preview {
    @include spaceCurve('padding-top', 'tiny');
    @include spaceCurve('padding-bottom', 'tiny');
    display: flex;
    align-items: center;
    opacity: 1;
    transform-origin: center;
  }

  &__preview.dz-error &__title,
  &__preview.dz-error &__link[href]:not([href='']),
  &__preview.dz-error &__link[href]:not([href='']):hover {
    color: $colorError60;
  }

  &__preview.dz-error &__error-message {
    display: block;
  }

  &__preview.dz-error &__meta {
    display: none;
  }

  &__preview.dz-complete:not(.dz-error) stzh-icon#{&}__delete-icon-error {
    display: none;
  }

  &__preview.dz-complete:not(.dz-error) stzh-icon#{&}__delete-icon {
    display: inline-flex;
  }

  &__preview.dz-complete &__info-wrapper-processing {
    display: none;
  }

  &__preview.dz-complete &__info-wrapper-complete {
    display: flex;
  }

  &__preview.dz-empty &__separator {
    display: none;
  }

  &__preview.dz-empty &__size {
    display: none;
  }

  // &__preview.dz-success {
  // }

  &__details {
    flex-grow: 1;
    display: flex;
    overflow: hidden;
  }

  &__info-wrapper {
    flex-grow: 1;
    display: flex;
    overflow: hidden;
  }

  &__info-wrapper-processing,
  &__info-wrapper-complete {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    overflow: hidden;
  }

  &__info-wrapper-complete {
    display: none;
  }

  &__actions {
    flex-shrink: 0;
    display: flex;
    align-items: center;

    &:not(:empty) {
      margin-left: space('xsmall');
    }
  }

  &__infos {
    @include fontSize('milli');
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__title,
  &__subtitle {
    @include truncate;
  }

  &__title {
    @include fontSize('milli');
  }

  &__link[href]:not([href='']) {
    color: $linkColor;

    &:hover {
      color: $linkHoverColor;
    }
  }

  &__meta {
    @include fontSize('nano');
    letter-spacing: 0.01em;
    display: flex;
    align-items: center;
    gap: space('xsmall');
  }

  &__info-wrapper-processing &__meta {
    display: none;
  }

  &__size strong {
    @include font;
  }

  // we don't display thumbnails currently
  // so we hide them
  &__image {
    display: none;
  }

  &__progress {
    display: block;
    height: 6px;
    background-color: $colorBlack20op;
    margin-top: space('xsmall');
  }

  &__progress-bar {
    display: block;
    height: 100%;
    width: 0;
    background: $colorSecondary40;
  }

  &__progress-text {
    @include fontSize('nano');
    letter-spacing: 0.01em;
    margin-left: space('medium');
    font-variant-numeric: tabular-nums;
  }

  &__separator {
    width: 1px;
    height: calc(100% - 4px);
    background-color: currentColor;
  }

  &__extension {
    text-transform: uppercase;
  }

  &__extension:empty + &__separator {
    display: none;
  }

  // &__download {
  //   &[variant="tertiary"] {
  //     display: none;
  //   }

  //   &[variant="tertiary"][href] {
  //     display: flex;
  //   }
  // }

  &__error-message {
    @include fontSize('nano');
    letter-spacing: 0.01em;
    color: $colorError60;
    transition: color $baseTransitionAnimationSpeed;
    display: none;
  }

  /* When upload has started */

  &.dz-started &__errors,
  &:has(#{&}__preview) &__errors {
    margin-top: space('medium');
  }

  /* While draging over dropzone */

  &.dz-drag-hover &__clickarea {
    background-color: $colorSecondary10;
    border-image-source: inline('./assets/border-active.png');

    @include retina() {
      border-image-source: inline('./assets/border-active@2x.png');
    }
  }

  &.dz-drag-hover &__heading-wrapper {
    color: #{$colorPrimary70};
  }

  /* Max files reached */

  &.dz-max-files-reached {

  }

  /* Hidden progressbar */

  &--has-hidden-progress &__progress,
  &--has-hidden-progress &__progress-text,
  &--has-hidden-progress-while-idle &__preview:not(.dz-processing) &__progress,
  &--has-hidden-progress-while-idle &__preview:not(.dz-processing) &__progress-text {
    display: none;
  }

  &--has-hidden-progress &__info-wrapper-processing &__meta,
  &--has-hidden-progress-while-idle &__preview:not(.dz-processing) &__info-wrapper-processing &__meta {
    display: flex;
  }

  /* Invalid */

  &--is-invalid &__clickarea {
    border-image-source: inline('./assets/border-error.png');

    @include retina() {
      border-image-source: inline('./assets/border-error@2x.png');
    }
  }

  &--has-description &__description {
    margin-top: space('small');
  }

  /* Disabled */

  &--is-disabled &__clickarea {
    cursor: not-allowed;
    background-color: $formDisabledBackgroundColor;
  }

  /* Photographing */

  &-photographing__info:not(:last-child) {
    @include spaceCurve('padding-bottom', 'large');
  }

  &-photographing__text-qrcode {
    display: flex;
    gap: space('large');
  }

  &-photographing-qrlink-container {
    width: 50%;
    flex-grow: 0;
    overflow-x: hidden;
  }

  &-photographing-qrcode-container {
    width: 50%;
    flex-grow: 1;
  }

  &-photographing-qrcode {
    width: 120px;
    height: 120px;

    @include mq($from: large) {
      width: 140px;
      height: 140px;
    }
  }

  &-photographing-link {
    @include spaceCurve('margin-top', 'intermediary');

    word-break: break-all !important;
    width: auto;
  }

  &-photographing__continue {
    display: flex;
    justify-content: flex-end;
    gap: space('large');
  }

  &-photographing__back-button {
    @include spaceCurve('margin-bottom', 'regular');
  }

  &__fade-out {
    opacity: 0;
    transition-duration: $uploadTransitionDuration;
    transition-delay: 0s;
    transition-property: opacity;
    transition-timing-function: ease-out;
  }

}
